import $ from 'jquery';
import lodash from 'lodash';
import { catalogPrices } from '../queries';
import { toCurrency } from './toCurrency';
import {toCashback} from "./toCashback";

const itemIsAvailable = (item) => {
    if (!item.isActive || !item.isAvailable || +item.storeAmount < 1) {
        return false;
    }
    return true;
};

const productsStorage = {};

export const updatePrices = async (isCashback = false,needUpdate = false) => {
    let products = [];
    $('.ui-value--product-price').each(function () {
        products.push(+$(this).attr('data-id'));
    });
    products = lodash.uniq(products).filter(item => item).filter(item => !productsStorage.hasOwnProperty(item));
    if ($('.js-bonuses-toggle').prop('checked')){
        isCashback = true;
    }
    if (needUpdate){
        $('.ui-value--product-price').each(function () {
            products.push(+$(this).attr('data-id'));
        });
    }
    if (products.length > 0) {
        const response = await catalogPrices(products,isCashback);

        if (response.isSuccess && response.items && Array.isArray(response.items)) {
            response.items.forEach(item => productsStorage[item.id] = item);
        }
    }

    Object.keys(productsStorage).forEach(key => {
        const item = productsStorage[key];

        const $price = $(`.ui-value--product-price[data-id="${item.id}"]`);
        const $priceBase = $(`.ui-value--product-price-base[data-id="${item.id}"]`);
        const $discountPercent = $(`.ui-value--product-discount-percent[data-id="${item.id}"]`);
        const $productQuantity = $(`.ui-product-quantity[data-external-id="${item.id}"]`);
        const $cashback = $(`.ui-value--product-cashback[data-id="${item.id}"]`);


        if (!itemIsAvailable(item)) {
            return;
        }

        $price.parents('.ui-product').addClass('ui-product--available')
            .find('.ui-button').removeClass('ui-button--disabled');

        $price.attr('data-price', item.price)
            .attr('data-price-level-2', item.priceLevel2)
            .attr('data-price-base', item.priceBase)
            .attr('data-discount', item.priceBase - item.price)
            .attr('data-amount', item.storeAmount)
            .attr('data-cashback', item.cashback)
            .text(toCurrency(item.price))
            .show();

        $productQuantity.attr('data-amount', item.storeAmount);
        const productQuantityValue = +$productQuantity.attr('data-quantity');
        if (productQuantityValue > item.storeAmount) {
            $productQuantity.trigger('change', item.storeAmount);
        }

        if(item.cashback){
            if (!$cashback.hasClass('catalog-detail-purchase__cashback--is-tooltip')){
                $cashback
                    .attr('data-cashback', item.cashback)
                    .text(toCashback(item.cashback))
                    .show()
            } else {
                $cashback
                    .attr('data-cashback', item.cashback)
                    .html(toCashback(item.cashback,true))
                    .css('display','flex')
            }
        }
        // if (+item.price < +item.priceBase) {
        //     $priceBase.attr('data-price', item.priceBase)
        //         .text(toCurrency(item.priceBase))
        //         .show();
        //
        //     const discountPercent = Math.floor((1 - (item.price / item.priceBase)) * 100);
        //     const roundedDiscountPercent = Math.round(discountPercent / 5) * 5; // Округляем до ближайшего числа, которое делится на 5 или равно 0
        //     $discountPercent.text(`-${roundedDiscountPercent}%`).show();
        // }
    });

    $('.ui-product').removeClass('ui-product--loading');

    $(document).trigger('prices-updated');
};
